export default "__VITE_ASSET__DwTimv60__"